<ng-container *ngIf="(layout$ | async)?.logo.isHyperLink">
  <a 
    href="https://www.biodigital.com"
    target="_blank"
    class="view-logo"
    tabindex="-1"
    title="Powered by Biodigital"
    [ngClass]="{
      'view-logo--full-color': (logoColor === 'color') && (logoSize === 'full'),
      'view-logo--full-white': (logoColor === 'white') && (logoSize === 'full'),
      'view-logo--small-color': (logoColor === 'color') && (logoSize === 'small'),
      'view-logo--small-white': (logoColor === 'white') && (logoSize === 'small')
    }">
  </a>
</ng-container>

<ng-container *ngIf="!(layout$ | async)?.logo.isHyperLink">
  <span 
    class="view-logo"
    [ngClass]="{
      'view-logo--full-color': (logoColor === 'color') && (logoSize === 'full'),
      'view-logo--full-white': (logoColor === 'white') && (logoSize === 'full'),
      'view-logo--small-color': (logoColor === 'color') && (logoSize === 'small'),
      'view-logo--small-white': (logoColor === 'white') && (logoSize === 'small')
    }">
  </span>
</ng-container>